<template>
	<AuthLogo />
	<!-- <DefaultHeader :title="$t('signUpPage.title')"></DefaultHeader> -->
	<div class="flex flex-col gap-4">
		<AuthGoogleLogin :redirectTo="($route.query?.redirectTo as string)" />
		<div class="flex items-center gap-2">
			<div class="flex-1 flex bg-gray-900 h-px rounded-xl"></div>
			<span class="text-sm leading-5 font-normal w-fit">
				{{ $t('signUpPage.or') }}
			</span>
			<div class="flex-1 flex bg-gray-900 h-px rounded-xl"></div>
		</div>
	</div>
	<form class="flex flex-col gap-6 mt-6" @submit.prevent="onSubmit">
		<DefaultInput
			id="email"
			v-model="email"
			:label="$t('signUpPage.emailLabel')"
			:placeholder="$t('signUpPage.emailPlaceholder')"
			type="email"
			required
		/>
		<DefaultPasswordInput
			:label="$t('signUpPage.passwordLabel')"
			:id="'password'"
			:placeholder="$t('signUpPage.passwordPlaceholder')"
			@update:passwordValue="value => (password = value)"
			required
			class="h-[120px]"
		/>
		<AccountSettingsSubscribeToNewsletter class="mt-4" @onChange="value => (newsletterSubscription = value)" />
		<DefaultCheckbox id="terms" v-model="agreedWithTerms" required>
			<a href="https://realitystudio.ai/privacy-policy" target="_blank" v-html="$t('signUpPage.terms')" />
		</DefaultCheckbox>
		<div class="flex flex-col gap-4">
			<DefaultHCaptcha ref="hCaptcha" @onVerify="token => (captchaToken = token)" v-if="platform === 'web'" />
			<DefaultButton type="submit" :isLoading="loading">
				{{ $t('signUpPage.signUpButton') }}
			</DefaultButton>
			<div class="text-lg leading-7 w-fit mx-auto">
				{{ $t('signUpPage.alreadyHaveAccount') }}
				<NuxtLink @click.native="$captureEvent('register_goto_login')" class="font-bold" to="login">
					{{ $t('signUpPage.signIn') }}
				</NuxtLink>
			</div>
		</div>
	</form>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { IUser } from '~/types/models/user.interface'

const userStore = useUserStore()
const router = useRouter()
const route = useRoute()
const email = ref('')
const password = ref('')
const captchaToken = ref('')
const loading = ref(false)
const agreedWithTerms = ref(false)
const newsletterSubscription = ref(false)

const { isMobile } = useDevice()
const platform = $getPlatform()
const { t } = useI18n()

const onSubmit = async () => {
	loading.value = true

	try {
		const locale = await $getLocale()

		const response: any = await $api('/auth/register', {
			method: 'POST',
			body: {
				email: email.value,
				password: password.value,
				token: captchaToken.value,
				locale,
				platform: platform.value,
				newsletterSubscription: newsletterSubscription.value,
			},
		})

		userStore.login(response.user as IUser)
		$captureEvent('register_submit_success')
		// sendTiktokCompleteRegistrationEvent(user);
		const nuxtApp: any = useNuxtApp()
		nuxtApp.$requestPushNotifications()

		const redirectTo = route.query?.redirectTo

		if (redirectTo) {
			router.push(redirectTo as string)
			return
		}

		router.push('/')
	} catch (error) {
		$sentryCaptureException(error)
		$captureEvent('register_submit_error')

		if (platform.value === 'web') {
			// $refs.hCaptcha.reset(); // @todo: fix this
		}

		$toast({
			type: 'error',
			title: t('common.toastTitle.error'),
			message: t('signUpPage.submitToastError'),
		})
	}

	loading.value = false
}
</script>
